exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".minVh[data-v-b7cab566]{min-height:60vh}.float[data-v-b7cab566]{position:fixed;width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;bottom:30px;right:70px}", ""]);

// exports
